<template>
    <BlockUI :blocked="proc">
      <ol class="page-breadcrumb breadcrumb">
        <router-link to="/" class="breadcrumb-item"> Dashboard </router-link>
        <router-link to="/collectionReport" class="breadcrumb-item textdecorationnone">
          <span class="colorbase">Collection Report</span>
        </router-link>
        <router-link to="/profitandloss" class="breadcrumb-item">
          <span>Profit & Loss</span>
        </router-link>
        <router-link to="/statement" class="breadcrumb-item">
          <span>My Stmt.</span>
        </router-link>
        <router-link to="/ledgers" class="breadcrumb-item">
          <span>Company Ledgers</span>
        </router-link>
        <router-link to="/liveGames" class="breadcrumb-item">
          <span>Live Matches</span>
        </router-link>
        <router-link to="/settledGames" class="breadcrumb-item">
          <span>Settled Matches</span>
        </router-link>
      </ol>
      <div class="row">
        <div class="col-md-4 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <div class="flex-fill fw-bold fs-16px">PAYMENT RECEIVING FROM (Lena Hai)</div>
              </div>
              <div class="d-flex align-items-center mb-2" v-for="d in comusersl" :key="d.N">
                <div class="flex-fill fw-bold fs-16px">
                  {{ d.N }}<span v-if="d.Dn">&nbsp;({{ d.Dn }})</span>
                </div>
                <div class="fw-bolder ms-auto text-success">{{ d.U.toLocaleString("en-IN") }}</div>
              </div>
              <div class="underline"></div>
              <div class="d-flex align-items-center mb-2">
                <div class="flex-fill fw-bold fs-16px">Total (Lena Hai)</div>
                <div class="fw-bolder ms-auto text-success">{{ totall.toLocaleString("en-IN") }}</div>
              </div>
            </div>
            <div class="card-arrow">
              <div class="card-arrow-top-left"></div>
              <div class="card-arrow-top-right"></div>
              <div class="card-arrow-bottom-left"></div>
              <div class="card-arrow-bottom-right"></div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <div class="flex-fill fw-bold fs-16px">PAYMENT PAID TO (Dena Hai)</div>
              </div>
              <div class="d-flex align-items-center mb-2" v-for="d in comusersr" :key="d.N">
                <div class="flex-fill fw-bold fs-16px">
                  {{ d.N }}<span v-if="d.Dn">&nbsp;({{ d.Dn }})</span>
                </div>
                <div class="fw-400 ms-auto text-danger">{{ d.U.toLocaleString("en-IN") }}</div>
              </div>
              <div class="underline"></div>
              <div class="d-flex align-items-center mb-2">
                <div class="flex-fill fw-bold fs-16px">Total (Dena Hai)</div>
                <div class="fw-bolder ms-auto text-danger">{{ totalr.toLocaleString("en-IN") }}</div>
              </div>
            </div>
            <div class="card-arrow">
              <div class="card-arrow-top-left"></div>
              <div class="card-arrow-top-right"></div>
              <div class="card-arrow-bottom-left"></div>
              <div class="card-arrow-bottom-right"></div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex align-items-center mb-3">
                <div class="flex-fill fw-bold fs-16px">PAYMENT Clear (Clear Hai)</div>
              </div>
              <div class="d-flex align-items-center mb-2" v-for="d in comuserszero" :key="d.N">
                <div class="flex-fill fw-bold fs-16px">
                  {{ d.N }}<span v-if="d.Dn">&nbsp;({{ d.Dn }})</span>
                </div>
                <small class="fw-400 ms-auto text-theme">{{ d.U.toLocaleString("en-IN") }}</small>
              </div>
            </div>
            <div class="card-arrow">
              <div class="card-arrow-top-left"></div>
              <div class="card-arrow-top-right"></div>
              <div class="card-arrow-bottom-left"></div>
              <div class="card-arrow-bottom-right"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="list-group">
            <a href="javascript:void(0);" class="list-group-item list-group-item-action d-flex align-items-center text-inverse">
              <div class="flex-fill px-3">
                <div class="fw-bold">Total (Lena Hai)</div>
              </div>
              <div>
                <span class="badge bg-transparent border border-theme text-success fs-12px fw-500 rounded-sm"> {{ totall.toLocaleString("en-in") }} </span>
              </div>
            </a>
            <a href="javascript:void(0);" class="list-group-item list-group-item-action d-flex align-items-center text-inverse">
              <div class="flex-fill px-3">
                <div class="fw-bold">Total (Dena Hai)</div>
              </div>
              <div>
                <span class="badge bg-transparent border border-theme text-danger fs-12px fw-500 rounded-sm"> {{ totalr.toLocaleString("en-in") }} </span>
              </div>
            </a>
            <a href="javascript:void(0);" class="list-group-item list-group-item-action d-flex align-items-center text-inverse">
              <div class="flex-fill px-3">
                <div class="fw-bold">Net Downline&nbsp;<span v-if="net >= 0">(Lena Hai)</span><span v-if="net < 0">(Dena Hai)</span></div>
              </div>
              <div>
                <span class="badge bg-transparent border border-theme fs-12px fw-500 rounded-sm" :class="{ 'text-success': net >= 0, 'text-danger': net < 0 }"> {{ net.toLocaleString("en-in") }} </span>
              </div>
            </a>
            <a href="javascript:void(0);" class="list-group-item list-group-item-action d-flex align-items-center text-inverse">
              <div class="flex-fill px-3">
                <div class="fw-bold">Upline</div>
              </div>
              <div>
                <span class="badge bg-transparent border border-theme fs-12px fw-500 rounded-sm" :class="{ 'text-success': upline >= 0, 'text-danger': upline < 0 }"> {{ upline.toLocaleString("en-in") }} </span>
              </div>
            </a>
            <!-- <a href="javascript:void(0);" class="list-group-item list-group-item-action d-flex align-items-center text-inverse">
              <div class="flex-fill px-3">
                <div class="fw-bold">Profit</div>
              </div>
              <div>
                <span class="badge bg-transparent border border-theme fs-12px fw-500 rounded-sm" :class="{ 'text-success': profit >= 0, 'text-danger': profit < 0 }"> {{ profit.toLocaleString("en-in") }} </span>
              </div>
            </a> -->
            <!-- <a href="javascript:void(0);" class="list-group-item list-group-item-action d-flex align-items-center text-inverse">
              <div class="flex-fill px-3">
                <div class="fw-bold">Cash</div>
              </div>
              <div>
                <span class="badge bg-transparent border border-theme fs-12px fw-500 rounded-sm" :class="{'text-success': cash >=0, 'text-danger': cash < 0}"> {{ cash.toLocaleString("en-in") }} </span>
              </div>
            </a> -->
          </div>
        </div>
      </div>
    </BlockUI>
  </template>
  
  <script>
  import $$vm from "@/data/index";
  import BlockUI from "primevue/blockui";
  
  export default {
    name: "CollectionReport",
    components: {
      BlockUI,
    },
    data() {
      return {
        comusersl: [],
        comusersr: [],
        comuserszero: [],
        totall: 0,
        totalr: 0,
        proc: false,
        profit: 0,
        cash: 0,
        upline: 0,
        net: 0,
      };
    },
    mounted() {
      var self = this;
      self.update();
    },
    methods: {
      update: function () {
        var self = this;
        if ($$vm.cn) {
          self.proc = true;
          $$vm.c.invoke("fs", "0").then(
            function (data) {
              data = $$vm.decompress(data);
              self.totall = 0;
              self.totalr = 0;
              self.comusersl = [];
              self.comusersr = [];
              self.cash = 0;
              //   var book = undefined;
              //   var upline = undefined;
              var index1 = -1;
              $.each(data, function (ii1, jj1) {
                if (jj1["N"].toLowerCase() === $$vm.bala.U.toLowerCase()) {
                  self.profit = jj1["D"];
                  self.upline = jj1["U"];
                  index1 = ii1;
                }
              });
              if (index1 !== -1) {
                data.splice(index1, 1);
              }
              $.each(data, function (ii, jj) {
                if (jj["U"] === 0) {
                  self.comuserszero.push(jj);
                } else if (jj["U"] < 0) {
                  self.comusersl.push(jj);
                  jj["U"] = -1 * jj["U"];
                  self.totall += jj["U"];
                } else {
                  jj["U"] = -1 * jj["U"];
                  self.comusersr.push(jj);
                  self.totalr += jj["U"];
                }
              });
              self.net = self.totall - Math.abs(self.totalr);
              //self.upline = (book !== undefined ? book["C"] : 0) + (upline !== undefined ? upline["C"] : 0);
              //   if (net >= 0) {
              //     //self.comusersl.push({ N: "upline", C: net });
              //     self.totall += net;
              //   } else {
              //     //self.comusersr.push({ N: "upline", C: net });
              //     self.totalr += net;
              //   }
              self.blockdates = false;
              self.proc = false;
            },
            function (err) {
              console.log(err);
              self.blockdates = false;
              self.proc = false;
            }
          );
        } else {
          setTimeout(function () {
            self.update();
          }, 200);
        }
      },
    },
  };
  </script>
  
  <style></style>
  